import PageLayout from "components/common/PageLayout";
import Header from "components/Header";
import Footer from "components/Footer";
import background from "../../assets/images/nosotros.mp4";

import { useTitle } from "react-use";

const Nosotros = () => {
  useTitle(`Nosotros | ${process.env.REACT_APP_PAGE_TITLE}`);

  return (
    <>
      <PageLayout>
        <Header />
        <main class="main-about">
          <div className="wrapper">
            <div className=" col-about-us">
              <div className="col col-1">
                <div className="about-us-textall">
                  <div className="head">
                    <h1>Quienes somos</h1>
                  </div>
                  <p className="we-text">
                    {" "}
                    Somos mucho más que una marca de ropa para perros.
                  </p>
                  <p className="we-text-info">
                    Somos amantes de los animales que, con pasión y compromiso,
                    hemos creado una marca dedicada a elevar el estándar de la
                    moda canina. Fundada por una familia emprendedora, que se
                    basa en la idea de que nuestros leales amigos peludos
                    merecen lo mejor.
                  </p>
                  <p className="we-text-2">Vanya y Chicago</p>
                </div>
              </div>
            </div>

            <div>
              <video
                className="background-video-we"
                autoPlay
                loop
                muted
                playsInline
              >
                <source src={background} type="video/mp4" />
              </video>
            </div>
          </div>
        </main>
      </PageLayout>
      <Footer />
    </>
  );
};

export default Nosotros;
